import React from 'react';

const AboutUs: React.FC = () => (
  <div className="max-w-3xl mx-auto py-16 px-4">
    <h1 className="text-5xl font-extrabold mb-6 bg-gradient-to-r from-blue-600 via-purple-500 to-pink-500 bg-clip-text text-transparent drop-shadow-lg flex items-center gap-3">
      <span>🌟</span> About Quicklish
    </h1>
    <div className="bg-white/80 rounded-2xl shadow-xl p-6 mb-8">
      <p className="text-xl font-semibold mb-4 text-gray-800">Quicklish empowers you to master English with <span className="bg-gradient-to-r from-pink-400 to-blue-400 bg-clip-text text-transparent font-bold">confidence, color, and fun</span>. Our mission is to make language learning accessible, engaging, and effective for everyone—no matter your background or starting point.</p>
    </div>
    <div className="border-l-4 border-blue-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-blue-700 flex items-center gap-2"><span>🎯</span> Our Mission</h2>
      <p className="mb-2 text-gray-700 text-lg">We believe that learning English should be joyful and motivating. That’s why we combine smart technology, real-world examples, and a supportive community to help you reach your goals.</p>
    </div>
    <div className="border-l-4 border-pink-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-pink-700 flex items-center gap-2"><span>✨</span> What Makes Us Unique?</h2>
      <ul className="list-disc list-inside mb-2 text-gray-700 text-lg">
        <li>Smart cards for grammar, sentences, and vocabulary—practice what matters most to you.</li>
        <li>Track your progress visually and celebrate every achievement.</li>
        <li>Multi-language support: Learn English from Hindi, Bengali, Marathi, Telugu, Tamil, Gujarati, and more.</li>
        <li>Personalized learning paths and instant feedback.</li>
        <li>Safe, private, and always free to start.</li>
      </ul>
    </div>
    <div className="border-l-4 border-yellow-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-yellow-700 flex items-center gap-2"><span>🚀</span> Our Vision</h2>
      <p className="mb-2 text-gray-700 text-lg">We’re building a world where everyone can communicate confidently in English, unlocking new opportunities and connections. Join us on this journey—<span className="font-bold text-pink-600">your success is our inspiration!</span></p>
    </div>
    <div className="mt-10 text-center">
      <span className="inline-block text-xl font-semibold text-blue-600 bg-blue-100 rounded-full px-6 py-2 shadow">Thank you for being part of the Quicklish family! 🎉</span>
    </div>
  </div>
);

export default AboutUs; 